import React from 'react';

import CancelablePromise from '../services/CancelablePromise';
import styled from '../styled-components';
import Icon from './Icon';

const imagePlaceholder = require('../images/image-placeholder.png');

type PropType = {
    src: string;
};

type StateType = {
    source: any;
    hasError: boolean;
};

class ImageLoader extends React.Component<PropType, StateType> {
    state = { source: imagePlaceholder, hasError: false };

    cancelablePromise: any;

    componentDidMount () {
        this.initialData()
    }

    initialData = async () => {
        try {
            const { src } = this.props;
            const isValid = await this.isImageValid(src);

            this.cancelablePromise = CancelablePromise(
                new Promise(r =>
                    this.setState({ source: !!isValid ? src : imagePlaceholder, hasError: !isValid }),
                ),
            );
        } catch (error) {
            console.warn(error);
        }
    }

    componentWillUnmount () {
        if (this.cancelablePromise) this.cancelablePromise.cancel();
    }

    isImageValid = (imageUrl: string) =>
        new Promise(resolve => {
            const img = new Image();
            img.src = imageUrl;
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
        });

    render () {
        const { source, hasError } = this.state;
        return (
            <Wrapper>
                {!hasError &&
                    source === imagePlaceholder && (
                        <IconWrapper>
                            <Icon name="spinner" spin />
                        </IconWrapper>
                    )}
                {!!hasError && (
                    <IconWrapper>
                        <Icon name="times" color="red" />
                    </IconWrapper>
                )}
                <ImageView className="image-loader-item" src={this.state.source} />
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`;

const IconWrapper = styled.div`
  font-size: 2rem;
  opacity: 0.5;
  position: absolute;
`;

const ImageView = styled.img`
  border: 1px solid #ddd;
  display: inline-block;
  max-height: 100%;
  max-width: 100%;
`;

export default ImageLoader;
